export default __webpack_public_path__ + "static/media/img_dataisnotavailable.3beed5f0.svg";